import React from 'react';
import TabDataIcon from '../../../../../Common/Icons/TabDataStatus';

type Props = {
  values: any
};

const RulesData = (props: Props) => {
  if (props.values) {
    if (props.values.render_markup_in_iframe
      || props.values.render_markup_inline
      || props.values.always_loose
      || (props.values.blocked_advertiser_categories && props.values.blocked_advertiser_categories.length > 0)
      || (props.values.blocked_advertiser_domains && props.values.blocked_advertiser_domains.length > 0)
      || (props.values.blocked_creative_attributes && props.values.blocked_creative_attributes.length > 0)
      || (props.values.blocked_creative_ids && props.values.blocked_creative_ids.length > 0)
      || props.values.ceiling
      || props.values.floor
      || props.values.price_scale) {
      return <TabDataIcon />;
    }
  }
  return null;
}

export default RulesData;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/AdQuality/Helpers/TabData/Rules.tsx